import React from 'react';
import { useSelector } from 'shared/node_modules/react-redux';
import { SELECTED_TERMS } from 'shared/constants';
import { openTermsAndConditionsByURL } from 'shared/utils/termsAndConditions';
import { getText, TEXT_KEY } from 'shared/utils/localization';

const DefaultTermsAndConditions = props => {
  const { getListButton, onChangeComponentHandler, screensEnum } = props;

  const { userProperty, propertySelector } = useSelector(state => state.properties.data);

  return (
    <>
      {getListButton(getText(TEXT_KEY.TERMS_AND_CONDITIONS), () => {
        if (!openTermsAndConditionsByURL({ userProperty, propertySelector, item: SELECTED_TERMS.TERMS }))
          onChangeComponentHandler(screensEnum.termsAndConditions);
      })}
      {getListButton(getText(TEXT_KEY.PRIVACY_POLICY), () => {
        if (
          !openTermsAndConditionsByURL({
            userProperty,
            propertySelector,
            item: SELECTED_TERMS.PRIVACY,
          })
        )
          onChangeComponentHandler(screensEnum.privacyPolicy);
      })}
    </>
  );
};

export default DefaultTermsAndConditions;

